// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// components
import { FormAddComponent } from '../../forms/FormAddComponent/FormAddComponent';

export interface DialogAddComponentProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
}

export const DialogAddComponent = ({ isOpen, onClose, onSuccess }: DialogAddComponentProps) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState<boolean>(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('addComponent'),
					loading: isLoading,
					form: 'form-add-component',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={700}
			onClose={onClose}
			title={{
				children: t('addComponent'),
				variant: 'h3',
			}}>
			<FormAddComponent onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
